import { useEffect, useState } from 'react';
import {
  PossibleCompetitorCompanyContract,
  getPossibleCompetitorCompanyContracts,
  peekPossibleCompetitorCompanyContracts,
} from 'services/actions/ai_management_possible_competitors';

export function usePossibleCompetitorCompanyContracts(
  biddingId: number | null,
  cnpj: string,
  biddingIds: number[],
) {
  const key = biddingIds.join(',');
  const peek = () =>
    biddingId ? peekPossibleCompetitorCompanyContracts(biddingId, cnpj, biddingIds) : undefined;
  const [contracts, setContracts] = useState<PossibleCompetitorCompanyContract[]>(
    () => peek()?.data.contratos ?? [],
  );
  const [loading, setLoading] = useState(() => !peek());
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!biddingId) {
      setContracts([]);
      setLoading(false);
      setError(true);
      return undefined;
    }

    const hit = peek();
    if (hit) {
      setContracts(hit.data.contratos ?? []);
      setLoading(false);
      setError(false);
      return undefined;
    }

    let active = true;
    setLoading(true);
    setError(false);

    getPossibleCompetitorCompanyContracts(biddingId, cnpj, biddingIds)
      .then(({ data }) => {
        if (!active) return;
        setContracts(data.contratos ?? []);
        setLoading(false);
      })
      .catch(() => {
        if (!active) return;
        setError(true);
        setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [biddingId, cnpj, key]);

  return { contracts, loading, error };
}
